module.exports = __webpack_public_path__ + "static/img/6.55baec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/6.png
// module id = Cqoz
// module chunks = 2